// eslint-disable-next-line import/no-named-default
import { default as NextLink } from 'next/link';
import { ReactNode, useEffect, useState } from 'react';

import { isBrowserIE } from 'utils/helper';

interface IProps {
  href: string;
  passHref?: boolean;
  children?: ReactNode;
  className?: string;
  target?: string;
}

const Link: React.FC<IProps> = ({
  children,
  href,
  passHref,
  className,
  target,
}) => {
  const [isIE, setIsIE] = useState<boolean>();
  useEffect(() => {
    setIsIE(isBrowserIE());
  }, []);

  if (isIE) {
    return (
      <a href={href} className={className} target={target}>
        {children}
      </a>
    );
  }

  return (
    <>
      {passHref ? (
        <NextLink href={href} passHref={passHref}>
          <a className={className} target={target}>
            {children}
          </a>
        </NextLink>
      ) : (
        <NextLink href={href}>{children}</NextLink>
      )}
    </>
  );
};

export default Link;
